module.exports = __webpack_public_path__ + "static/media/04-icon.58ef9637.svg";